import { render } from "./CompanySwitch.vue?vue&type=template&id=4b2dfad5"
import script from "./CompanySwitch.vue?vue&type=script&lang=js"
export * from "./CompanySwitch.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__